import React from 'react';
import { Link } from 'react-router-dom';

function Projects() {
    return (
        <div className="container">
            <div id="contentsection1">
            <div className="desc">
                <h2> Project: compscichris.org [Started: 8/2025, Status: In progress]</h2>
                <ul id="descList">
                    <li>AWS hosted website, with my own domain name</li>
                    <li>HTML, CSS implemented: JavaScript: yet to implement something interesting yet</li>
                    <li>Static Website hosting</li>
                    <li>Not yet finished listing accomplishments and finishing webpage content</li>
                </ul>
            </div>
            <div className="desc">
                <h2> Project: 
                    <Link to={`/projects/proj1`}>Raspberry Pi GPU node</Link>
                    [Started: 11/2025, Status: Finished/Ongoing]
                </h2>
                <ul id="descList">
                    <li>Raspberry Pi 5 SBC node with Nvidia GPU in a Raspberry Pi Cluster</li>
                    <li>Nvidia T1000 GPU configured on Raspberry Pi Trixie 13.</li>
                    <li>GPU acceleration testing confirms the driver and patches compatibility</li>
                    <li>Thanks to Jeff Geerling, and mariobalanica</li>
                    <li>Video output compatibility may be explored in the future with SBC</li>
                </ul>
            </div>
            <div className="desc">
                <h2> Project: Raspberry Pi Cluster [Started: 11/2025, Status: Finished/Ongoing]</h2>
                <ul id="descList">
                    <li>Raspberry Pi 5 SBC node with Nvidia GPU in a Raspberry Pi Cluster</li>
                    <li>Nvidia T1000 GPU configured on Raspberry Pi Trixie 13.</li>
                    <li>GPU acceleration testing confirms the driver and patches compatibility</li>
                    <li>Thanks to Jeff Geerling, and mariobalanica</li>
                    <li>Video output compatibility may be explored in the future with SBC</li>
                </ul>
            </div>
        </div>
        </div>
    );
}

export default Projects;

